export default '/build/151de58e.svg'